const SCENARIOS = [
  {
    anchor: 'spread',
    icon: 'ri-bar-chart-2-line',
    accent: '#059669',
    tag: 'So sánh Spread Forex/CFD',
    title: 'So sánh chi phí mở lệnh',
    desc: 'Đối chiếu mức spread của nhiều sàn cho cùng một sản phẩm giao dịch.',
    cta: 'So sánh Spread',
  },
  {
    anchor: 'swap',
    icon: 'ri-moon-line',
    accent: '#7c3aed',
    tag: 'So sánh Swap Forex/CFD',
    title: 'So sánh phí giữ lệnh qua đêm',
    desc: 'Tính phí swap khi giữ vị thế Long hoặc Short qua nhiều đêm.',
    cta: 'So sánh Swap',
  },
  {
    anchor: 'product',
    icon: 'ri-information-line',
    accent: '#f59e0b',
    tag: 'Kiểm tra thông số sản phẩm',
    title: 'Kiểm tra thông số chi tiết',
    desc: 'Xem contract size, giá trị pip, khối lượng và ký quỹ của sản phẩm.',
    cta: 'Kiểm tra thông số',
  },
];

export default function ScenarioCards({ onSelect }: { onSelect: (anchor: string) => void }) {
  return (
    <div>
      <h2 className="font-display text-xl font-bold text-slate-900">Bạn đang so sánh điều gì?</h2>
      <div className="mt-5 grid grid-cols-1 gap-4 md:grid-cols-3">
        {SCENARIOS.map((s) => (
          <button
            key={s.anchor}
            type="button"
            onClick={() => onSelect(s.anchor)}
            className="group relative flex flex-col rounded-3xl border border-slate-200/80 bg-white p-6 text-left transition-all duration-300 hover:-translate-y-1 hover:border-transparent"
            style={{ boxShadow: '0 10px 30px -20px rgba(15,23,42,0.12)' }}
          >
            <span
              className="absolute inset-x-0 top-0 h-1 origin-left rounded-t-3xl transition-transform duration-500"
              style={{ backgroundColor: s.accent, transform: 'scaleX(0)' }}
            />
            <div className="flex items-center justify-between">
              <span
                className="flex h-11 w-11 items-center justify-center rounded-xl"
                style={{ backgroundColor: `${s.accent}1a`, color: s.accent }}
              >
                <i className={`${s.icon} text-xl`} />
              </span>
              <span
                className="rounded-full px-2.5 py-0.5 text-[10px] font-semibold uppercase tracking-wide"
                style={{ backgroundColor: `${s.accent}14`, color: s.accent }}
              >
                {s.tag}
              </span>
            </div>
            <h3 className="mt-4 font-display text-lg font-bold text-slate-900">{s.title}</h3>
            <p className="mt-1.5 text-sm leading-relaxed text-slate-500">{s.desc}</p>
            <span className="mt-5 inline-flex items-center gap-1.5 text-sm font-semibold" style={{ color: s.accent }}>
              {s.cta}
              <i className="ri-arrow-right-line transition-transform group-hover:translate-x-0.5" />
            </span>
          </button>
        ))}
      </div>
    </div>
  );
}